export const HEADING = 'Depression details';
